const subnationalUnits = [
  {
    countryId: "124", // canada
    name: 'Newfoundland and Labrador',
    code: 'NL',
    id: 'CA-NL',
  },
  {
    countryId: "124", // canada
    name: 'Prince Edward Island',
    code: 'PE',
    id: 'CA-PE',
  },
  {
    countryId: "124", // canada
    name: 'Nova Scotia',
    code: 'NS',
    id: 'CA-NS',
  },
  {
    countryId: "124", // canada
    name: 'New Brunswick',
    code: 'NB',
    id: 'CA-NB',
  },
  {
    countryId: "124", // canada
    name: 'Quebec',
    code: 'QC',
    id: 'CA-QC',
  },
  {
    countryId: "124", // canada
    name: 'Ontario',
    code: 'ON',
    id: 'CA-ON',
  },
  {
    countryId: "124", // canada
    name: 'Manitoba',
    code: 'MB',
    id: 'CA-MB',
  },
  {
    countryId: "124", // canada
    name: 'Saskatchewan',
    code: 'SK',
    id: 'CA-SK',
  },
  {
    countryId: "124", // canada
    name: 'Alberta',
    code: 'AB',
    id: 'CA-AB',
  },
  {
    countryId: "124", // canada
    name: 'British Columbia',
    code: 'BC',
    id: 'CA-BC',
  },
  {
    countryId: "124", // canada
    name: 'Yukon',
    code: 'YT',
    id: 'CA-YT',
  },
  {
    countryId: "124", // canada
    name: 'Northwest Territories',
    code: 'NT',
    id: 'CA-NT',
  },
  {
    countryId: "124", // canada
    name: 'Nunavut',
    code: 'NU',
    id: 'CA-NU',
  },
  {
    countryId: "036", // australia
    name: "New South Wales",
    code: "NSW",
    id: "AU-NSW",
  },
    {
    countryId: "036", // australia
    name: "Victoria",
    code: "VIC",
    id: "AU-VIC",
  },
    {
    countryId: "036", // australia
    name: "Queensland",
    code: "QLD",
    id: "AU-QLD",
  },
    {
    countryId: "036", // australia
    name: "South Australia",
    code: "SA",
    id: "AU-SA",
  },
    {
    countryId: "036", // australia
    name: "Western Australia",
    code: "WA",
    id: "AU-WA",
  },
    {
    countryId: "036", // australia
    name: "Tasmania",
    code: "TAS",
    id: "AU-TAS",
  },
    {
    countryId: "036", // australia
    name: "Northern Territory",
    code: "NT",
    id: "AU-NT",
  },
  {
    countryId: "036", // australia
    name: "Australian Capital Territory",
    code: "ACT",
    id: "AU-ACT",
  },
  {
    countryId: "826", // UK
    name: 'North East',
    code: 'NE',
    id: 'UK-NE',
  },
  {
    countryId: "826",
    name: 'North West',
    code: 'NW',
    id: 'UK-NW',
  },
  {
    countryId: "826",
    name: 'Yorkshire and The Humber',
    code: 'YatH',
    id: 'UK-YatH',
  },
  {
    countryId: "826",
    name: 'East Midlands',
    code: 'EM',
    id: 'UK-EM',
  },
  {
    countryId: "826",
    name: 'West Midlands',
    code: 'WM',
    id: 'UK-WM',
  },
  {
    countryId: "826",
    name: 'East of England',
    code: 'E',
    id: 'UK-E',
  },
  {
    countryId: "826",
    name: 'London',
    code: 'L',
    id: 'UK-L',
  },
  {
    countryId: "826",
    name: 'South East',
    code: 'SE',
    id: 'UK-SE',
  },
  {
    countryId: "826", // UK
    name: 'South West',
    code: 'SW',
    id: 'UK-SW',
  },
  {
    countryId: "826", // UK
    name: 'England',
    code: 'E92000001',
    id: 'GB-ENG',
  },
  {
    countryId: "826", // UK
    name: 'Scotland',
    code: 'S92000003',
    id: 'GB-SCT',
  },
  {
    countryId: "826", // UK
    name: 'Wales',
    code: 'W92000004',
    id: 'GB-WLS',
  },
  {
    countryId: "826", // UK
    name: 'Northern Ireland',
    code: 'N92000002',
    id: 'GB-NIR',
  },
  {
    countryId: "710", // South Africa
    name: 'Eastern Cape',
    code: 'EC',
    id: 'ZA-EC',
  },
  {
    countryId: "710", // South Africa
    name: 'Free State',
    code: 'FS',
    id: 'ZA-FS',
  },
  {
    countryId: "710", // South Africa
    name: 'Gauteng',
    code: 'GP',
    id: 'ZA-GP',
  },
  {
    countryId: "710", // South Africa
    name: 'KwaZulu-Natal',
    code: 'KZN',
    id: 'ZA-KZN',
  },
  {
    countryId: "710", // South Africa
    name: 'Limpopo',
    code: 'LP',
    id: 'ZA-LP',
  },
  {
    countryId: "710", // South Africa
    name: 'Mpumalanga',
    code: 'MP',
    id: 'ZA-MP',
  },
  {
    countryId: "710", // South Africa
    name: 'North West',
    code: 'NW',
    id: 'ZA-NW',
  },
  {
    countryId: "710", // South Africa
    name: 'Northern Cape',
    code: 'NC',
    id: 'ZA-NC',
  },
  {
    countryId: "710", // South Africa
    name: 'Western Cape',
    code: 'WC',
    id: 'ZA-WC',
  },
  {
    countryId: "276", // Germany
    name: 'Baden-Württemberg',
    jhName: 'Baden-Wurttemberg',
    code: 'BW',
    id: 'DE-BW',
  },
  {
    countryId: "276", // Germany
    name: 'Bavaria',
    jhName: 'Bayern',
    code: 'BY',
    id: 'DE-BY',
  },
  {
    countryId: "276", // Germany
    name: 'Berlin',
    code: 'BE',
    id: 'DE-BE',
  },
  {
    countryId: "276", // Germany
    name: 'Brandenburg',
    code: 'BB',
    id: 'DE-BB',
  },
  {
    countryId: "276", // Germany
    name: 'Bremen',
    code: 'HB',
    id: 'DE-HB',
  },
  {
    countryId: "276", // Germany
    name: 'Hamburg',
    code: 'HH',
    id: 'DE-HH',
  },
  {
    countryId: "276", // Germany
    name: 'Hesse',
    jhName: 'Hessen',
    code: 'HE',
    id: 'DE-HE',
  },
  {
    countryId: "276", // Germany
    name: 'Mecklenburg-Vorpommern',
    code: 'MV',
    id: 'DE-MV',
  },
  {
    countryId: "276", // Germany
    name: 'Lower Saxony',
    jhName: 'Niedersachsen',
    code: 'NI',
    id: 'DE-NI',
  },
  {
    countryId: "276", // Germany
    name: 'North Rhine-Westphalia',
    jhName: 'Nordrhein-Westfalen',
    code: 'NW',
    id: 'DE-NW',
  },
  {
    countryId: "276", // Germany
    name: 'Rhineland-Palatinate',
    jhName: 'Rheinland-Pfalz',
    code: 'RP',
    id: 'DE-RP',
  },
  {
    countryId: "276", // Germany
    name: 'Saarland',
    code: 'SL',
    id: 'DE-SL',
  },
  {
    countryId: "276", // Germany
    name: 'Saxony',
    jhName: 'Sachsen',
    code: 'SN',
    id: 'DE-SN',
  },
  {
    countryId: "276", // Germany
    name: 'Saxony-Anhalt',
    jhName: 'Sachsen-Anhalt',
    code: 'ST',
    id: 'DE-ST',
  },
  {
    countryId: "276", // Germany
    name: 'Schleswig-Holstein',
    code: 'SH',
    id: 'DE-SH',
  },
  {
    countryId: "276", // Germany
    name: 'Thuringia',
    jhName: 'Thuringen',
    code: 'TH',
    id: 'DE-TH',
  },
  {
    countryId: "566", // Nigeria
    name: 'Lagos',
    code: 'LA',
    id: 'NG-LA',
  },
  {
    countryId: "566", // Nigeria
    name: 'Federal Capital Territory',
    code: 'FCT',
    id: 'NG-FC',
  },
  {
    countryId: "566", // Nigeria
    name: 'Oyo',
    code: 'OY',
    id: 'NG-OY',
  },
  {
    countryId: "566", // Nigeria
    name: 'Edo',
    code: 'ED',
    id: 'NG-ED',
  },
  {
    countryId: "566", // Nigeria
    name: 'Delta',
    code: 'DE',
    id: 'NG-DE',
  },
  {
    countryId: "566", // Nigeria
    name: 'Kano',
    code: 'KN',
    id: 'NG-KN',
  },
  {
    countryId: "566", // Nigeria
    name: 'Rivers',
    code: 'RI',
    id: 'NG-RI',
  },
  {
    countryId: "566", // Nigeria
    name: 'Ogun',
    code: 'OG',
    id: 'NG-OG',
  },
  {
    countryId: "566", // Nigeria
    name: 'Kaduna',
    code: 'KD',
    id: 'NG-KD',
  },
  {
    countryId: "566", // Nigeria
    name: 'Katsina',
    code: 'KT',
    id: 'NG-KT',
  },
  {
    countryId: "566", // Nigeria
    name: 'Ondo',
    code: 'ON',
    id: 'NG-ON',
  },
  {
    countryId: "566", // Nigeria
    name: 'Borno',
    code: 'BO',
    id: 'NG-BO',
  },
  {
    countryId: "566", // Nigeria
    name: 'Gombe',
    code: 'GO',
    id: 'NG-GO',
  },
  {
    countryId: "566", // Nigeria
    name: 'Bauchi',
    code: 'BA',
    id: 'NG-BA',
  },
  {
    countryId: "566", // Nigeria
    name: 'Ebonyi',
    code: 'EB',
    id: 'NG-EB',
  },
  {
    countryId: "566", // Nigeria
    name: 'Plateau',
    code: 'PL',
    id: 'NG-PL',
  },
  {
    countryId: "566", // Nigeria
    name: 'Enugu',
    code: 'EN',
    id: 'NG-EN',
  },
  {
    countryId: "566", // Nigeria
    name: 'Abia',
    code: 'AB',
    id: 'NG-AB',
  },
  {
    countryId: "566", // Nigeria
    name: 'Imo',
    code: 'IM',
    id: 'NG-IM',
  },
  {
    countryId: "566", // Nigeria
    name: 'Jigawa',
    code: 'JI',
    id: 'NG-JI',
  },
  {
    countryId: "566", // Nigeria
    name: 'Kwara',
    code: 'KW',
    id: 'NG-KW',
  },
  {
    countryId: "566", // Nigeria
    name: 'Bayelsa',
    code: 'BY',
    id: 'NG-BY',
  },
  {
    countryId: "566", // Nigeria
    name: 'Nasarawa',
    code: 'NA',
    id: 'NG-NA',
  },
  {
    countryId: "566", // Nigeria
    name: 'Osun',
    code: 'OS',
    id: 'NG-OS',
  },
  {
    countryId: "566", // Nigeria
    name: 'Sokoto',
    code: 'SO',
    id: 'NG-SO',
  },
  {
    countryId: "566", // Nigeria
    name: 'Akwa Ibom',
    code: 'AK',
    id: 'NG-AK',
  },
  {
    countryId: "566", // Nigeria
    name: 'Niger',
    code: 'NI',
    id: 'NG-NI',
  },
  {
    countryId: "566", // Nigeria
    name: 'Benue',
    code: 'BE',
    id: 'NG-BE',
  },
  {
    countryId: "566", // Nigeria
    name: 'Adamawa',
    code: 'AD',
    id: 'NG-AD',
  },
  {
    countryId: "566", // Nigeria
    name: 'Anambra',
    code: 'AN',
    id: 'NG-AN',
  },
  {
    countryId: "566", // Nigeria
    name: 'Kebbi',
    code: 'KE',
    id: 'NG-KE',
  },
  {
    countryId: "566", // Nigeria
    name: 'Zamfara',
    code: 'ZA',
    id: 'NG-ZA',
  },
  {
    countryId: "566", // Nigeria
    name: 'Yobe',
    code: 'YO',
    id: 'NG-YO',
  },
  {
    countryId: "566", // Nigeria
    name: 'Ekiti',
    code: 'EK',
    id: 'NG-EK',
  },
  {
    countryId: "566", // Nigeria
    name: 'Taraba',
    code: 'TA',
    id: 'NG-TA',
  },
  {
    countryId: "566", // Nigeria
    name: 'Cross River',
    code: 'CR',
    id: 'NG-CR',
  },
  {
    countryId: "566", // Nigeria
    name: 'Kogi',
    code: 'KO',
    id: 'NG-KO',
  },
  {
    countryId: "356", // India
    name: 'Andhra Pradesh',
    code: 'AP',
    id: 'IN-AP',
  },
  {
    countryId: "356", // India
    name: 'Telangana',
    code: 'TG',
    id: 'IN-TG',
  },
  {
    countryId: "356", // India
    name: 'Chhattisgarh',
    code: 'CT',
    id: 'IN-CT',
  },
  {
    countryId: "356", // India
    name: 'Uttarakhand',
    code: 'UT',
    id: 'IN-UT',
  },
  {
    countryId: "356", // India
    name: 'Tripura',
    code: 'TR',
    id: 'IN-TR',
  },
  {
    countryId: "356", // India
    name: 'Goa',
    code: 'GA',
    id: 'IN-GA',
  },
  {
    countryId: "356", // India
    name: 'Tamil Nadu',
    code: 'TN',
    id: 'IN-TN',
  },
  {
    countryId: "356", // India
    name: 'Sikkim',
    code: 'SK',
    id: 'IN-SK',
  },
  {
    countryId: "356", // India
    name: 'Bihar',
    code: 'BR',
    id: 'IN-BR',
  },
  {
    countryId: "356", // India
    name: 'Mizoram',
    code: 'MZ',
    id: 'IN-MZ',
  },
  {
    countryId: "356", // India
    name: 'Haryana',
    code: 'HR',
    id: 'IN-HR',
  },
  {
    countryId: "356", // India
    name: 'Jharkhand',
    code: 'JH',
    id: 'IN-JH',
  },
  {
    countryId: "356", // India
    name: 'Gujarat',
    code: 'GJ',
    id: 'IN-GJ',
  },
  {
    countryId: "356", // India
    name: 'Karnataka',
    code: 'KA',
    id: 'IN-KA',
  },
  {
    countryId: "356", // India
    name: 'Arunachal Pradesh',
    code: 'AR',
    id: 'IN-AR',
  },
  {
    countryId: "356", // India
    name: 'Lakshadweep',
    code: 'LD',
    id: 'IN-LD',
  },
  {
    countryId: "356", // India
    name: 'Rajasthan',
    code: 'RJ',
    id: 'IN-RJ',
  },
  {
    countryId: "356", // India
    name: 'Meghalaya',
    code: 'ML',
    id: 'IN-ML',
  },
  {
    countryId: "356", // India
    name: 'Andaman and Nicobar Islands',
    topoName: 'Andaman & Nicobar Islands',
    code: 'AN',
    id: 'IN-AN',
  },
  {
    countryId: "356", // India
    name: 'Himachal Pradesh',
    code: 'HP',
    id: 'IN-HP',
  },
  {
    countryId: "356", // India
    name: 'Nagaland',
    code: 'NL',
    id: 'IN-NL',
  },
  {
    countryId: "356", // India
    name: 'West Bengal',
    code: 'WB',
    id: 'IN-WB',
  },
  {
    countryId: "356", // India
    name: 'Odisha',
    code: 'OR',
    id: 'IN-OR',
  },
  {
    countryId: "356", // India
    name: 'Manipur',
    code: 'MN',
    id: 'IN-MN',
  },
  {
    countryId: "356", // India
    name: 'Jammu and Kashmir',
    code: 'JK',
    id: 'IN-JK',
  },
  {
    countryId: "356", // India
    name: 'Chandigarh',
    code: 'CH',
    id: 'IN-CH',
  },
  {
    countryId: "356", // India
    name: 'Uttar Pradesh',
    code: 'UP',
    id: 'IN-UP',
  },
  {
    countryId: "356", // India
    name: 'Assam',
    code: 'AS',
    id: 'IN-AS',
  },
  {
    countryId: "356", // India
    name: 'Maharashtra',
    code: 'MH',
    id: 'IN-MH',
  },
  {
    countryId: "356", // India
    name: 'Kerala',
    code: 'KL',
    id: 'IN-KL',
  },
  {
    countryId: "356", // India
    name: 'Delhi', // NCT of Delhi
    code: 'DL',
    id: 'IN-DL',
  },
  {
    countryId: "356", // India
    name: 'Punjab',
    code: 'PB',
    id: 'IN-PB',
  },
  {
    countryId: "356", // India
    name: 'Madhya Pradesh',
    code: 'MP',
    id: 'IN-MP',
  },
  {
    countryId: "356", // India
    name: 'Puducherry',
    code: 'PY',
    id: 'IN-PY',
  },
  {
    countryId: "356", // India
    name: 'Dadra and Nagar Haveli and Daman and Diu',
    code: 'DD',
    id: 'IN-DD',
  },
  {
    countryId: "356", // India
    name: 'Ladakh',
    code: 'LA',
    id: 'IN-LA',
  },
  {
    countryId: "076", // Brazil
    name: 'Mato Grosso do Sul',
    code: 'MS',
    id: 'BR-MS',
  },
  {
    countryId: "076", // Brazil
    name: 'Santa Catarina',
    code: 'SC',
    id: 'BR-SC',
  },
  {
    countryId: "076", // Brazil
    name: 'Espírito Santo',
    jhName: 'Espirito Santo',
    code: 'ES',
    id: 'BR-ES',
  },
  {
    countryId: "076", // Brazil
    name: 'Acre',
    code: 'AC',
    id: 'BR-AC',
  },
  {
    countryId: "076", // Brazil
    name: 'Rio Grande do Sul',
    code: 'RS',
    id: 'BR-RS',
  },
  {
    countryId: "076", // Brazil
    name: 'Mato Grosso',
    code: 'MT',
    id: 'BR-MT',
  },
  {
    countryId: "076", // Brazil
    name: 'Roraima',
    code: 'RR',
    id: 'BR-RR',
  },
  {
    countryId: "076", // Brazil
    name: 'Paraíba',
    jhName: 'Paraiba',
    code: 'PB',
    id: 'BR-PB',
  },
  {
    countryId: "076", // Brazil
    name: 'Piauí',
    jhName: 'Piaui',
    code: 'PI',
    id: 'BR-PI',
  },
  {
    countryId: "076", // Brazil
    name: 'Goiás',
    jhName: 'Goias',
    code: 'GO',
    id: 'BR-GO',
  },
  {
    countryId: "076", // Brazil
    name: 'Rio Grande do Norte',
    code: 'RN',
    id: 'BR-RN',
  },
  {
    countryId: "076", // Brazil
    name: 'Rio de Janeiro',
    code: 'RJ',
    id: 'BR-RJ',
  },
  {
    countryId: "076", // Brazil
    name: 'Paraná',
    jhName: 'Parana',
    code: 'PR',
    id: 'BR-PR',
  },
  {
    countryId: "076", // Brazil
    name: 'Amapá',
    jhName: 'Amapa',
    code: 'AP',
    id: 'BR-AP',
  },
  {
    countryId: "076", // Brazil
    name: 'São Paulo',
    jhName: 'Sao Paulo',
    code: 'SP',
    id: 'BR-SP',
  },
  {
    countryId: "076", // Brazil
    name: 'Distrito Federal',
    code: 'DF',
    id: 'BR-DF',
  },
  {
    countryId: "076", // Brazil
    name: 'Bahia',
    code: 'BA',
    id: 'BR-BA',
  },
  {
    countryId: "076", // Brazil
    name: 'Pará',
    jhName: 'Para',
    code: 'PA',
    id: 'BR-PA',
  },
  {
    countryId: "076", // Brazil
    name: 'Pernambuco',
    code: 'PE',
    id: 'BR-PE',
  },
  {
    countryId: "076", // Brazil
    name: 'Maranhão',
    jhName: 'Maranhao',
    code: 'MA',
    id: 'BR-MA',
  },
  {
    countryId: "076", // Brazil
    name: 'Tocantins',
    code: 'TO',
    id: 'BR-TO',
  },
  {
    countryId: "076", // Brazil
    name: 'Ceará',
    jhName: 'Ceara',
    code: 'CE',
    id: 'BR-CE',
  },
  {
    countryId: "076", // Brazil
    name: 'Rondônia',
    jhName: 'Rondonia',
    code: 'RO',
    id: 'BR-RO',
  },
  {
    countryId: "076", // Brazil
    name: 'Amazonas',
    code: 'AM',
    id: 'BR-AM',
  },
  {
    countryId: "076", // Brazil
    name: 'Sergipe',
    code: 'SE',
    id: 'BR-SE',
  },
  {
    countryId: "076", // Brazil
    name: 'Minas Gerais',
    code: 'MG',
    id: 'BR-MG',
  },
  {
    countryId: "076", // Brazil
    name: 'Alagoas',
    code: 'AL',
    id: 'BR-AL',
  },
  {
    countryId: "410", // Korea
    name: "Seoul",
    code: '11',
    id: 'KR-11',
  },
  {
    countryId: "410", // Korea
    name: "Busan",
    code: '26',
    id: 'KR-26',
  },
  {
    countryId: "410", // Korea
    name: "Daegu",
    code: '27',
    id: 'KR-27',
  },
  {
    countryId: "410", // Korea
    name: "Incheon",
    code: '28',
    id: 'KR-28',
  },
  {
    countryId: "410", // Korea
    name: "Gwangju",
    code: '29',
    id: 'KR-29',
  },
  {
    countryId: "410", // Korea
    name: "Daejeon",
    code: '30',
    id: 'KR-30',
  },
  {
    countryId: "410", // Korea
    name: "Ulsan",
    code: '31',
    id: 'KR-31',
  },
  {
    countryId: "410", // Korea
    name: "Sejong",
    code: '50',
    id: 'KR-50',
  },
  {
    countryId: "410", // Korea
    name: "Gyeonggi-do",
    code: '41',
    id: 'KR-41',
  },
  {
    countryId: "410", // Korea
    name: "Gangwon-do",
    code: '42',
    id: 'KR-42',
  },
  {
    countryId: "410", // Korea
    name: "Chungcheongbuk-do",
    code: '43',
    id: 'KR-43',
  },
  {
    countryId: "410", // Korea
    name: "Chungcheongnam-do",
    code: '44',
    id: 'KR-44',
  },
  {
    countryId: "410", // Korea
    name: "Jeollabuk-do",
    code: '45',
    id: 'KR-45',
  },
  {
    countryId: "410", // Korea
    name: "Jeollanam-do",
    code: '46',
    id: 'KR-46',
  },
  {
    countryId: "410", // Korea
    name: "Gyeongsangbuk-do",
    code: '47',
    id: 'KR-47',
  },
  {
    countryId: "410", // Korea
    name: "Gyeongsangnam-do",
    code: '48',
    id: 'KR-48',
  },
  {
    countryId: "410", // Korea
    name: "Jeju",
    code: '49',
    id: 'KR-49',
  },
  //
  {
    countryId: "586", // Pakistan
    name: "Azad Jammu and Kashmir",
    code: 'AJK',
    id: 'PK-AJK',
  },
  {
    countryId: "586", // Pakistan
    name: "Balochistan",
    code: 'BA',
    id: 'PK-BA',
  },
  {
    countryId: "586", // Pakistan
    name: "Gilgit-Baltistan",
    code: 'GB',
    id: 'PK-GB',
  },
  {
    countryId: "586", // Pakistan
    name: "Islamabad Capital Territory",
    code: 'IS',
    id: 'PK-IS',
  },
  {
    countryId: "586", // Pakistan
    name: "Khyber Pakhtunkhwa",
    code: 'KP',
    id: 'PK-KP',
  },
  {
    countryId: "586", // Pakistan
    name: "Punjab",
    code: 'PB',
    id: 'PK-PB',
  },
  {
    countryId: "586", // Pakistan
    name: "Sindh",
    code: 'SD',
    id: 'PK-SD',
  },
  {
    countryId: "724", // Spain
    jhName: "Andalusia",
    name: 'Andalucía',
    code: 'AN',
    id: 'SP-AN',
  },
  {
    countryId: "724", // Spain
    name: 'Cataluña',
    jhName: "Catalonia",
    code: 'CT',
    id: 'SP-CT',
  },
  {
    countryId: "724", // Spain
    name: 'Madrid',
    populationName: 'Community of Madrid',
    topoName: 'Comunidad de Madrid',
    code: 'MD',
    id: 'SP-MD',
  },
  {
    countryId: "724", // Spain
    name: 'Comunidad Valenciana',
    populationName: 'Valencian Community',
    jhName: 'C. Valenciana',
    code: 'VC',
    id: 'SP-VC',
  },
  {
    countryId: "724", // Spain
    name: 'Galicia',
    code: 'GA',
    id: 'SP-GA',
  },
  {
    countryId: "724", // Spain
    name: 'Castilla y León',
    populationName: 'Castile and León',
    jhName: 'Castilla y Leon',
    code: 'CL',
    id: 'SP-CL',
  },
  {
    countryId: "724", // Spain
    name: 'País Vasco',
    jhName: 'Pais Vasco',
    populationName: 'Basque Autonomous Community',
    code: 'PV',
    id: 'SP-PV',
  },
  {
    countryId: "724", // Spain
    name: 'Castilla-La Mancha',
    jhName: 'Castilla - La Mancha',
    populationName: 'Castilla-La Mancha',
    code: 'CM',
    id: 'SP-CM',
  },
  {
    countryId: "724", // Spain
    name: 'Islas Canarias',
    jhName: 'Canarias',
    populationName: 'Canary Islands',
    code: 'CN',
    id: 'SP-CN',
  },
  {
    countryId: "724", // Spain
    name: 'Región de Murcia',
    topoName: 'Región de Murcia',
    jhName: 'Murcia',
    populationName: 'Region of Murcia',
    code: 'MU',
    id: 'SP-MU',
  },
  {
    countryId: "724", // Spain
    name: 'Aragón',
    jhName: 'Aragon',
    code: 'AR',
    id: 'SP-AR',
  },
  {
    countryId: "724", // Spain
    name: 'Extremadura',
    code: 'EX',
    id: 'SP-EX',
  },
  {
    countryId: "724", // Spain
    name: 'Islas Baleares',
    populationName: 'Balearic Islands',
    jhName: 'Baleares',
    code: 'PM',
    id: 'SP-PM',
  },
  {
    countryId: "724", // Spain
    name: 'Principado de Asturias',
    populationName: 'Principality of Asturias',
    jhName: 'Asturias',
    code: 'AS',
    id: 'SP-AS',
  },
  {
    countryId: "724", // Spain
    name: 'Comunidad Foral de Navarra',
    populationName: 'Chartered Community of Navarre',
    jhName: 'Navarra',
    code: 'NA',
    id: 'SP-NA',
  },
  {
    countryId: "724", // Spain
    name: 'Cantabria',
    code: 'CB',
    id: 'SP-CB',
  },
  {
    countryId: "724", // Spain
    name: 'La Rioja',
    code: 'LO',
    id: 'SP-LO',
  },
  {
    countryId: "380", // Italy
    name: 'Abruzzo',
    code: 'AB',
    id: 'IT-AB',
  },
  {
    countryId: "380", // Italy
    name: 'Aosta Valley',
    jhName: 'Valle d\'Aosta',
    code: 'AV',
    id: 'IT-AV',
  },
  {
    countryId: "380", // Italy
    name: 'Apulia',
    jhName: 'Puglia',
    code: 'AP',
    id: 'IT-AP',
  },
  {
    countryId: "380", // Italy
    name: 'Basilicata',
    code: 'BA',
    id: 'IT-BA',
  },
  {
    countryId: "380", // Italy
    name: 'Calabria',
    code: 'CA',
    id: 'IT-CA',
  },
  {
    countryId: "380", // Italy
    name: 'Campania',
    code: 'CM',
    id: 'IT-CM',
  },
  {
    countryId: "380", // Italy
    name: 'Emilia-Romagna',
    code: 'ER',
    id: 'IT-ER',
  },
  {
    countryId: "380", // Italy
    name: 'Friuli Venezia Giulia',
    topoName: 'Friuli-Venezia Giulia',
    code: 'FV',
    id: 'IT-FV',
  },
  {
    countryId: "380", // Italy
    name: 'Lazio',
    code: 'LZ',
    id: 'IT-LZ',
  },
  {
    countryId: "380", // Italy
    name: 'Liguria',
    code: 'LG',
    id: 'IT-LG',
  },
  {
    countryId: "380", // Italy
    name: 'Lombardy',
    topoName: 'Lombardia',
    code: 'LO',
    id: 'IT-LO',
  },
  {
    countryId: "380", // Italy
    name: 'Marche',
    code: 'MR',
    id: 'IT-MR',
  },
  {
    countryId: "380", // Italy
    name: 'Molise',
    code: 'MO',
    id: 'IT-MO',
  },
  {
    countryId: "380", // Italy
    name: 'Piedmont',
    topoName: 'Piemonte',
    code: 'PD',
    id: 'IT-PD',
  },
  {
    countryId: "380", // Italy
    name: 'Sardinia',
    jhName: 'Sardegna',
    code: 'SR',
    id: 'IT-SR',
  },
  {
    countryId: "380", // Italy
    name: 'Sicily',
    jhName: 'Sicilia',
    code: 'SI',
    id: 'IT-SI',
  },
  {
    countryId: "380", // Italy
    name: 'Trentino-South Tyrol',
    topoName: 'Trentino-Alto Adige',
    jhName: 'P.A. Trento',
    code: 'TA',
    id: 'IT-TA',
  },
  {
    countryId: "380", // Italy
    name: 'Tuscany',
    jhName: 'Toscana',
    code: 'TS',
    id: 'IT-TS',
  },
  {
    countryId: "380", // Italy
    name: 'Umbria',
    code: 'UM',
    id: 'IT-UM',
  },
  {
    countryId: "380", // Italy
    name: 'Veneto',
    code: 'VN',
    id: 'IT-VN',
  },
  {
    countryId: "484", // Mexico
    name: 'Aguascalientes',
    code: 'AG',
    id: 'MX-AG',
  },
  {
    countryId: "484", // Mexico
    name: 'Baja California',
    code: 'BC',
    id: 'MX-BC',
  },
  {
    countryId: "484", // Mexico
    name: 'Baja California Sur',
    code: 'BS',
    id: 'MX-BS',
  },
  {
    countryId: "484", // Mexico
    name: 'Campeche',
    code: 'CA',
    id: 'MX-CA',
  },
  {
    countryId: "484", // Mexico
    name: 'Chiapas',
    code: 'CH',
    id: 'MX-CH',
  },
  {
    countryId: "484", // Mexico
    name: 'Aguascalientes',
    code: 'AG',
    id: 'MX-AG',
  },
  {
    countryId: "484", // Mexico
    name: 'Mexico City',
    topoName: 'Distrito Federal',
    jhName: 'Ciudad de Mexico',
    code: 'MC',
    id: 'MX-MC',
  },
  {
    countryId: "484", // Mexico
    name: 'Chihuahua',
    code: 'CI',
    id: 'MX-CI',
  },
  {
    countryId: "484", // Mexico
    name: 'Coahuila',
    topoName: 'Coahuila de Zaragoza',
    code: 'CO',
    id: 'MX-CO',
  },
  {
    countryId: "484", // Mexico
    name: 'Colima',
    code: 'CL',
    id: 'MX-CL',
  },
  {
    countryId: "484", // Mexico
    name: 'Durango',
    code: 'DU',
    id: 'MX-DU',
  },
  {
    countryId: "484", // Mexico
    name: 'Guanajuato',
    code: 'GJ',
    id: 'MX-GJ',
  },
  {
    countryId: "484", // Mexico
    name: 'Guerrero',
    code: 'GU',
    id: 'MX-GU',
  },
  {
    countryId: "484", // Mexico
    name: 'Hidalgo',
    code: 'HI',
    id: 'MX-HI',
  },
  {
    countryId: "484", // Mexico
    name: 'Jalisco',
    code: 'JA',
    id: 'MX-JA',
  },

  {
    countryId: "484", // Mexico
    name: 'Mexico',
    populationName: 'México',
    code: 'MX',
    id: 'MX-MX',
  },
  {
    countryId: "484", // Mexico
    name: 'Michoacán',
    jhName: 'Michoacan',
    topoName: 'Michoacán de Ocampo',
    code: 'MI',
    id: 'MX-MI',
  },
  {
    countryId: "484", // Mexico
    name: 'Morelos',
    code: 'MO',
    id: 'MX-MO',
  },
  {
    countryId: "484", // Mexico
    name: 'Nayarit',
    code: 'NA',
    id: 'MX-NA',
  },
  {
    countryId: "484", // Mexico
    name: 'Nuevo León',
    jhName: 'Nuevo Leon',
    code: 'NL',
    id: 'MX-NL',
  },
  {
    countryId: "484", // Mexico
    name: 'Oaxaca',
    code: 'OX',
    id: 'MX-OX',
  },
  {
    countryId: "484", // Mexico
    name: 'Puebla',
    code: 'PB',
    id: 'MX-PB',
  },
  {
    countryId: "484", // Mexico
    name: 'Querétaro',
    jhName: 'Queretaro',
    code: 'QT',
    id: 'MX-QT',
  },
  {
    countryId: "484", // Mexico
    name: 'Quintana Roo',
    code: 'QR',
    id: 'MX-QR',
  },
  {
    countryId: "484", // Mexico
    name: 'San Luis Potosí',
    jhName: 'San Luis Potosi',
    code: 'SL',
    id: 'MX-SL',
  },
  {
    countryId: "484", // Mexico
    name: 'Sinaloa',
    code: 'SN',
    id: 'MX-SN',
  },
  {
    countryId: "484", // Mexico
    name: 'Sonora',
    code: 'SO',
    id: 'MX-SO',
  },
  {
    countryId: "484", // Mexico
    name: 'Tabasco',
    code: 'TB',
    id: 'MX-TB',
  },
  {
    countryId: "484", // Mexico
    name: 'Tamaulipas',
    code: 'TM',
    id: 'MX-TM',
  },
  {
    countryId: "484", // Mexico
    name: 'Tlaxcala',
    code: 'TL',
    id: 'MX-TL',
  },
  {
    countryId: "484", // Mexico
    name: 'Veracruz',
    topoName: 'Veracruz de Ignacio de la Llave',
    code: 'VC',
    id: 'MX-VC',
  },
  {
    countryId: "484", // Mexico
    name: 'Yucatán',
    jhName: 'Yucatan',
    code: 'YC',
    id: 'MX-YC',
  },
  {
    countryId: "484", // Mexico
    name: 'Zacatecas',
    code: 'ZA',
    id: 'MX-ZA',
  },
  {
    countryId: "392", // Japan
    name: 'Aichi',
    code: 'AI',
    id: 'JP-AI',
  },
  {
    countryId: "392", // Japan
    name: 'Akita',
    code: 'AK',
    id: 'JP-AK',
  },
  {
    countryId: "392", // Japan
    name: 'Aomori',
    code: 'AO',
    id: 'JP-AO',
  },
  {
    countryId: "392", // Japan
    name: 'Chiba',
    code: 'CB',
    id: 'JP-CB',
  },
  {
    countryId: "392", // Japan
    name: 'Ehime',
    code: 'EH',
    id: 'JP-EH',
  },
  {
    countryId: "392", // Japan
    name: 'Fukui',
    code: 'FI',
    id: 'JP-FI',
  },
  {
    countryId: "392", // Japan
    name: 'Fukuoka',
    code: 'FK',
    id: 'JP-FK',
  },
  {
    countryId: "392", // Japan
    name: 'Fukushima',
    code: 'FM',
    id: 'JP-FM',
  },
  {
    countryId: "392", // Japan
    name: 'Gifu',
    code: 'GF',
    id: 'JP-GF',
  },
  {
    countryId: "392", // Japan
    name: 'Gunma',
    code: 'GM',
    id: 'JP-GM',
  },
  {
    countryId: "392", // Japan
    name: 'Hiroshima',
    code: 'HI',
    id: 'JP-HI',
  },
  {
    countryId: "392", // Japan
    name: 'Hokkaido',
    code: 'HO',
    id: 'JP-HO',
  },
  {
    countryId: "392", // Japan
    name: 'Hyōgo',
    jhName: 'Hyogo',
    code: 'HY',
    id: 'JP-HY',
  },
  {
    countryId: "392", // Japan
    name: 'Ibaraki',
    code: 'IB',
    id: 'JP-IB',
  },
  {
    countryId: "392", // Japan
    name: 'Ishikawa',
    code: 'IK',
    id: 'JP-IK',
  },
  {
    countryId: "392", // Japan
    name: 'Iwate',
    code: 'IW',
    id: 'JP-IW',
  },
  {
    countryId: "392", // Japan
    name: 'Kagawa',
    code: 'KA',
    id: 'JP-KA',
  },
  {
    countryId: "392", // Japan
    name: 'Kagoshima',
    code: 'KG',
    id: 'JP-KG',
  },
  {
    countryId: "392", // Japan
    name: 'Kanagawa',
    code: 'KN',
    id: 'JP-KN',
  },
  {
    countryId: "392", // Japan
    name: 'Kōchi',
    jhName: 'Kochi',
    code: 'KO',
    id: 'JP-KO',
  },
  {
    countryId: "392", // Japan
    name: 'Kumamoto',
    code: 'KU',
    id: 'JP-KU',
  },
  {
    countryId: "392", // Japan
    name: 'Kyoto',
    code: 'KY',
    id: 'JP-KY',
  },
  {
    countryId: "392", // Japan
    name: 'Mie',
    code: 'MI',
    id: 'JP-MI',
  },
  {
    countryId: "392", // Japan
    name: 'Miyagi',
    code: 'MY',
    id: 'JP-MY',
  },
  {
    countryId: "392", // Japan
    name: 'Miyazaki',
    code: 'MZ',
    id: 'JP-MZ',
  },
  {
    countryId: "392", // Japan
    name: 'Nagano',
    code: 'NG',
    id: 'JP-NG',
  },
  {
    countryId: "392", // Japan
    name: 'Nagasaki',
    topoName: 'Naoasaki',
    code: 'NS',
    id: 'JP-NS',
  },
  {
    countryId: "392", // Japan
    name: 'Nara',
    code: 'NA',
    id: 'JP-NA',
  },
  {
    countryId: "392", // Japan
    name: 'Niigata',
    code: 'NI',
    id: 'JP-NI',
  },
  {
    countryId: "392", // Japan
    name: 'Ōita',
    jhName: 'Oita',
    code: 'OI',
    id: 'JP-OI',
  },
  {
    countryId: "392", // Japan
    name: 'Okayama',
    code: 'OY',
    id: 'JP-OY',
  },
  {
    countryId: "392", // Japan
    name: 'Okinawa',
    code: 'OK',
    id: 'JP-OK',
  },
  {
    countryId: "392", // Japan
    name: 'Osaka',
    code: 'OS',
    id: 'JP-OS',
  },
  {
    countryId: "392", // Japan
    name: 'Saga',
    code: 'SG',
    id: 'JP-SG',
  },
  {
    countryId: "392", // Japan
    name: 'Saitama',
    code: 'ST',
    id: 'JP-ST',
  },
  {
    countryId: "392", // Japan
    name: 'Shiga',
    code: 'SH',
    id: 'JP-SH',
  },
  {
    countryId: "392", // Japan
    name: 'Shimane',
    code: 'SM',
    id: 'JP-SM',
  },
  {
    countryId: "392", // Japan
    name: 'Shizuoka',
    code: 'SZ',
    id: 'JP-SZ',
  },
  {
    countryId: "392", // Japan
    name: 'Tochigi',
    code: 'TC',
    id: 'JP-TC',
  },
  {
    countryId: "392", // Japan
    name: 'Tokushima',
    code: 'TK',
    id: 'JP-TK',
  },
  {
    countryId: "392", // Japan
    name: 'Tokyo',
    code: 'TO',
    id: 'JP-TO',
  },
  {
    countryId: "392", // Japan
    name: 'Tottori',
    code: 'TT',
    id: 'JP-TT',
  },
  {
    countryId: "392", // Japan
    name: 'Toyama',
    code: 'TY',
    id: 'JP-TY',
  },
  {
    countryId: "392", // Japan
    name: 'Wakayama',
    code: 'WK',
    id: 'JP-WK',
  },
  {
    countryId: "392", // Japan
    name: 'Yamagata',
    code: 'YA',
    id: 'JP-YA',
  },
  {
    countryId: "392", // Japan
    name: 'Yamaguchi',
    code: 'YG',
    id: 'JP-YG',
  },
  {
    countryId: "392", // Japan
    name: 'Yamanashi',
    code: 'YM',
    id: 'JP-YM',
  },
  {
    countryId: "604", // Peru
    name: 'Amazonas',
    code: 'AZ',
    id: 'PE-AZ',
  },
  {
    countryId: "604", // Peru
    name: 'Ancash',
    code: 'AN',
    id: 'PE-AN',
  },
  {
    countryId: "604", // Peru
    name: 'Apurímac',
    jhName: 'Apurimac',
    code: 'AP',
    id: 'PE-AP',
  },
  {
    countryId: "604", // Peru
    name: 'Arequipa',
    code: 'AR',
    id: 'PE-AR',
  },
  {
    countryId: "604", // Peru
    name: 'Ayacucho',
    code: 'AY',
    id: 'PE-AY',
  },
  {
    countryId: "604", // Peru
    name: 'Cajamarca',
    code: 'CJ',
    id: 'PE-CJ',
  },
  {
    countryId: "604", // Peru
    name: 'Callao',
    code: 'CA',
    id: 'PE-CA',
  },
  {
    countryId: "604", // Peru
    name: 'Cusco',
    code: 'CU',
    id: 'PE-CU',
  },
  {
    countryId: "604", // Peru
    name: 'Huancavelica',
    code: 'HC',
    id: 'PE-HC',
  },
  {
    countryId: "604", // Peru
    name: 'Huánuco',
    jhName: 'Huanuco',
    code: 'HU',
    id: 'PE-HU',
  },
  {
    countryId: "604", // Peru
    name: 'Ica',
    code: 'IC',
    id: 'PE-IC',
  },
  {
    countryId: "604", // Peru
    name: 'Junín',
    jhName: 'Junin',
    code: 'JU',
    id: 'PE-JU',
  },
  {
    countryId: "604", // Peru
    name: 'La Libertad',
    code: 'LL',
    id: 'PE-LL',
  },
  {
    countryId: "604", // Peru
    name: 'Lambayeque',
    code: 'LB',
    id: 'PE-LB',
  },
  {
    countryId: "604", // Peru
    name: 'Lima',
    code: 'LI',
    id: 'PE-LI',
  },
  {
    countryId: "604", // Peru
    name: 'Loreto',
    code: 'LO',
    id: 'PE-LO',
  },
  {
    countryId: "604", // Peru
    name: 'Madre de Dios',
    code: 'MD',
    id: 'PE-MD',
  },
  {
    countryId: "604", // Peru
    name: 'Moquegua',
    code: 'MO',
    id: 'PE-MO',
  },
  {
    countryId: "604", // Peru
    name: 'Pasco',
    code: 'PA',
    id: 'PE-PA',
  },
  {
    countryId: "604", // Peru
    name: 'Piura',
    code: 'PI',
    id: 'PE-PI',
  },
  {
    countryId: "604", // Peru
    name: 'Puno',
    code: 'PU',
    id: 'PE-PU',
  },
  {
    countryId: "604", // Peru
    name: 'San Martín',
    jhName: 'San Martin',
    code: 'SM',
    id: 'PE-SM',
  },
  {
    countryId: "604", // Peru
    name: 'Tacna',
    code: 'TC',
    id: 'PE-TC',
  },
  {
    countryId: "604", // Peru
    name: 'Tumbes',
    code: 'TB',
    id: 'PE-TB',
  },
  {
    countryId: "604", // Peru
    name: 'Ucayali',
    code: 'UC',
    id: 'PE-UC',
  },
  {
    countryId: "170", // Colombia
    name: 'Amazonas',
    code: 'AZ',
    id: 'CO-AZ',
  },
  {
    countryId: "170", // Colombia
    name: 'Capital District',
    code: 'CD',
    id: 'CO-CD',
  },
  {
    countryId: "170", // Colombia
    name: 'Antioquia',
    code: 'AN',
    id: 'CO-AN',
  },
  {
    countryId: "170", // Colombia
    name: 'Arauca',
    code: 'AR',
    id: 'CO-AR',
  },
  {
    countryId: "170", // Colombia
    name: 'Atlántico',
    jhName: 'Atlantico',
    code: 'AT',
    id: 'CO-AT',
  },
  {
    countryId: "170", // Colombia
    name: 'Bolívar',
    jhName: 'Bolivar',
    code: 'BO',
    id: 'CO-BO',
  },
  {
    countryId: "170", // Colombia
    name: 'Boyacá',
    jhName: 'Boyaca',
    code: 'BY',
    id: 'CO-BY',
  },
  {
    countryId: "170", // Colombia
    name: 'Caldas',
    code: 'CL',
    id: 'CO-CL',
  },
  {
    countryId: "170", // Colombia
    name: 'Caquetá',
    jhName: 'Caqueta',
    code: 'CQ',
    id: 'CO-CQ',
  },
  {
    countryId: "170", // Colombia
    name: 'Casanare',
    code: 'CS',
    id: 'CO-CS',
  },
  {
    countryId: "170", // Colombia
    name: 'Cauca',
    code: 'CC',
    id: 'CO-CC',
  },
  {
    countryId: "170", // Colombia
    name: 'Cesar',
    code: 'CE',
    id: 'CO-CE',
  },
  {
    countryId: "170", // Colombia
    name: 'Chocó',
    jhName: 'Choco',
    code: 'CH',
    id: 'CO-CH',
  },
  {
    countryId: "170", // Colombia
    name: 'Córdoba',
    jhName: 'Cordoba',
    code: 'CO',
    id: 'CO-CO',
  },
  {
    countryId: "170", // Colombia
    name: 'Cundinamarca',
    code: 'CU',
    id: 'CO-CU',
  },
  {
    countryId: "170", // Colombia
    name: 'Guainía',
    jhName: 'Guainia',
    code: 'GU',
    id: 'CO-GU',
  },
  {
    countryId: "170", // Colombia
    name: 'Guaviare',
    code: 'GV',
    id: 'CO-GV',
  },
  {
    countryId: "170", // Colombia
    name: 'Huila',
    code: 'HU',
    id: 'CO-HU',
  },
  {
    countryId: "170", // Colombia
    name: 'La Guajira',
    code: 'LG',
    id: 'CO-LG',
  },
  {
    countryId: "170", // Colombia
    name: 'Magdalena',
    code: 'MG',
    id: 'CO-MG',
  },
  {
    countryId: "170", // Colombia
    name: 'Meta',
    code: 'MT',
    id: 'CO-MT',
  },
  {
    countryId: "170", // Colombia
    name: 'Nariño',
    jhName: 'Narino',
    code: 'NR',
    id: 'CO-NR',
  },
  {
    countryId: "170", // Colombia
    name: 'Norte de Santander',
    code: 'NS',
    id: 'CO-NS',
  },
  {
    countryId: "170", // Colombia
    name: 'Putumayo',
    code: 'PM',
    id: 'CO-PM',
  },
  {
    countryId: "170", // Colombia
    name: 'Quindío',
    jhName: 'Quindio',
    code: 'QD',
    id: 'CO-QD',
  },
  {
    countryId: "170", // Colombia
    name: 'Risaralda',
    code: 'RS',
    id: 'CO-RS',
  },
  {
    countryId: "170", // Colombia
    name: 'San Andrés y Providencia',
    jhName: 'San Andres y Providencia',
    code: 'SA',
    id: 'CO-SA',
  },
  {
    countryId: "170", // Colombia
    name: 'Santander',
    code: 'ST',
    id: 'CO-ST',
  },
  {
    countryId: "170", // Colombia
    name: 'Sucre',
    code: 'SU',
    id: 'CO-SU',
  },
  {
    countryId: "170", // Colombia
    name: 'Tolima',
    code: 'TO',
    id: 'CO-TO',
  },
  {
    countryId: "170", // Colombia
    name: 'Valle del Cauca',
    code: 'VC',
    id: 'CO-VC',
  },
  {
    countryId: "170", // Colombia
    name: 'Vaupés',
    jhName: 'Vaupes',
    code: 'VA',
    id: 'CO-VA',
  },
  {
    countryId: "170", // Colombia
    name: 'Vichada',
    code: 'VI',
    id: 'CO-VI',
  },
  {
    countryId: "528", // Netherlands
    name: 'Drenthe',
    code: 'DR',
    id: 'NL-DR',
  },
  {
    countryId: "528", // Netherlands
    name: 'Flevoland',
    code: 'FL',
    id: 'NL-FL',
  },
  {
    countryId: "528", // Netherlands
    name: 'Friesland',
    code: 'FR',
    id: 'NL-FR',
  },
  {
    countryId: "528", // Netherlands
    name: 'Gelderland',
    code: 'GD',
    id: 'NL-GD',
  },
  {
    countryId: "528", // Netherlands
    name: 'Groningen',
    code: 'GR',
    id: 'NL-GR',
  },
  {
    countryId: "528", // Netherlands
    name: 'Limburg',
    code: 'LB',
    id: 'NL-LB',
  },
  {
    countryId: "528", // Netherlands
    name: 'North Brabant',
    topoName: 'Noord-Brabant',
    code: 'NB',
    id: 'NL-NB',
  },
  {
    countryId: "528", // Netherlands
    name: 'North Holland',
    topoName: 'Noord-Holland',
    code: 'NH',
    id: 'NL-NH',
  },
  {
    countryId: "528", // Netherlands
    name: 'Overijssel',
    code: 'OJ',
    id: 'NL-OJ',
  },
  {
    countryId: "528", // Netherlands
    name: 'South Holland',
    topoName: 'Zuid-Holland',
    code: 'SH',
    id: 'NL-SH',
  },
  {
    countryId: "528", // Netherlands
    name: 'Utrecht',
    code: 'UT',
    id: 'NL-UT',
  },
  {
    countryId: "528", // Netherlands
    name: 'Zeeland',
    code: 'ZE',
    id: 'NL-ZE',
  },
  {
    countryId: "804", // Ukraine
    name: 'Cherkasy Oblast',
    code: 'UA',
    id: 'UA-CK',
  },
  {
    "countryId": "804",
    "name": "Chernihiv Oblast",
    "code": "CH",
    "id": "UA-CH"
  },
  {
    "countryId": "804",
    "name": "Chernivtsi Oblast",
    "code": "CV",
    "id": "UA-CV"
  },
  {
    "countryId": "804",
    "topoName": "Crimea Autonomous Republic",
    name: 'Crimea',
    jhName: 'Crimea Republic*',
    "code": "KR",
    "id": "UA-KR"
  },
  {
    "countryId": "804",
    "name": "Dnipropetrovs'k Oblast",
    jhName: 'Dnipropetrovsk Oblast',
    "code": "DP",
    "id": "UA-DP"
  },
  {
    "countryId": "804",
    "name": "Donets'k Oblast",
    jhName: 'Donetsk Oblast',
    "code": "DT",
    "id": "UA-DT"
  },
  {
    "countryId": "804",
    "name": "Ivano-Frankivs'k Oblast",
    jhName: 'Ivano-Frankivsk Oblast',
    "code": "IF",
    "id": "UA-IF"
  },
  {
    "countryId": "804",
    "name": "Kharkiv Oblast",
    "code": "KK",
    "id": "UA-KK"
  },
  {
    "countryId": "804",
    "name": "Kherson Oblast",
    "code": "KS",
    "id": "UA-KS"
  },
  {
    "countryId": "804",
    "name": "Khmel'nyts'kyy Oblast",
    jhName: 'Khmelnytskyi Oblast',
    "code": "KM",
    "id": "UA-KM"
  },
  {
    "countryId": "804",
    "name": "Kiev Oblast",
    "code": "KV",
    "id": "UA-KV"
  },
  {
    "countryId": "804",
    "name": "Kiev City Independent City",
    jhName: 'Kiev',
    populationName: 'Kiev City',
    "code": "KC",
    "id": "UA-KC"
  },
  {
    "countryId": "804",
    "name": "Kirovohrad Oblast",
    "code": "KH",
    "id": "UA-KH"
  },
  {
    "countryId": "804",
    "name": "Luhans'k Oblast",
    jhName: 'Luhansk Oblast',
    "code": "LH",
    "id": "UA-LH"
  },
  {
    "countryId": "804",
    "name": "L'viv Oblast",
    jhName: 'Lviv Oblast',
    "code": "LV",
    "id": "UA-LV"
  },
  {
    "countryId": "804",
    "name": "Mykolayiv Oblast",
    jhName: 'Mykolaiv Oblast',
    "code": "MY",
    "id": "UA-MY"
  },
  {
    "countryId": "804",
    "name": "Odessa Oblast",
    "code": "OD",
    "id": "UA-OD"
  },
  {
    "countryId": "804",
    "name": "Poltava Oblast",
    "code": "PL",
    "id": "UA-PL"
  },
  {
    "countryId": "804",
    "name": "Rivne Oblast",
    "code": "RV",
    "id": "UA-RV"
  },
  {
    "countryId": "804",
    "populationName" : "Sevastopol' Autonomous Republic",
    name: "Sevastopol",
    jhName: 'Sevastopol*',

    "code": "SC",
    "id": "UA-SC"
  },
  {
    "countryId": "804",
    "name": "Sumy Oblast",
    "code": "SM",
    "id": "UA-SM"
  },
  {
    "countryId": "804",
    "name": "Ternopil' Oblast",
    jhName: 'Ternopil Oblast',
    "code": "TP",
    "id": "UA-TP"
  },
  {
    "countryId": "804",
    "name": "Transcarpathia Oblast",
    jhName: 'Zakarpattia Oblast',
    "code": "ZK",
    "id": "UA-ZK"
  },
  {
    "countryId": "804",
    "name": "Vinnytsya Oblast",
    jhName: 'Vinnytsia Oblast',
    "code": "VI",
    "id": "UA-VI"
  },
  {
    "countryId": "804",
    "name": "Volyn Oblast",
    "code": "VO",
    "id": "UA-VO"
  },
  {
    "countryId": "804",
    "name": "Zaporizhzhya Oblast",
    jhName: 'Zaporizhia Oblast',
    "code": "ZP",
    "id": "UA-ZP"
  },
  {
    "countryId": "804",
    "name": "Zhytomyr Oblast",
    "code": "ZT",
    "id": "UA-ZT"
  },
  {
    "countryId": "152", //Chile
    "name": "Arica and Parinacota",
    jhName: 'Arica y Parinacota',
    topoName: 'Región de Arica y Parinacota',
    "code": "AP",
    "id": "CH-AP"
  },
  {
    "countryId": "152", //Chile
    "name": "Tarapacá",
    jhName: 'Tarapaca',
    "code": "TA",
    "id": "CH-TA"
  },
  {
    "countryId": "152", //Chile
    "name": "Antofagasta",
    "code": "AF",
    "id": "CH-AF"
  },
  {
    "countryId": "152", //Chile
    "name": "Atacama",
    "code": "AT",
    "id": "CH-AT"
  },
  {
    "countryId": "152", //Chile
    "name": "Coquimbo",
    "code": "CQ",
    "id": "CH-CQ"
  },
  {
    "countryId": "152", //Chile
    "name": "Valparaíso",
    jhName: 'Valparaiso',
    "code": "VP",
    "id": "CH-VP"
  },
  {
    "countryId": "152", //Chile
    "name": "Santiago",
    topoName: 'Región Metropolitana de Santiago',
    jhName: 'Metropolitana',
    "code": "SN",
    "id": "CH-SN"
  },
  {
    "countryId": "152", //Chile
    "name": "O'Higgins",
    jhName: 'OHiggins',
    topoName: 'Libertador Bernardo O\'Higgins',
    "code": "OH",
    "id": "CH-OH"
  },
  {
    "countryId": "152", //Chile
    "name": "Maule",
    "code": "MA",
    "id": "CH-MA"
  },
  {
    "countryId": "152", //Chile
    "name": "Ñubl",
    "jhName": "Nubl",
    "code": "NB",
    "id": "CH-NB"
  },
  {
    "countryId": "152", //Chile
    "name": "Biobío",
    jhName: 'Biobio',
    topoName: 'Bío-Bío',
    "code": "BB",
    "id": "CH-BB"
  },
  {
    "countryId": "152", //Chile
    "name": "Araucanía",
    jhName: 'Araucania',
    topoName: 'La Araucana',
    "code": "AR",
    "id": "CH-AR"
  },
  {
    "countryId": "152", //Chile
    "name": "Los Ríos",
    jhName: 'Los Rios',
    "code": "LR",
    "id": "CH-LR"
  },
  {
    "countryId": "152", //Chile
    "name": "Los Lagos",
    "code": "LL",
    "id": "CH-LL"
  },
  {
    "countryId": "152", //Chile
    "name": "Aysén",
    jhName: 'Aysen',
    topoName: 'Aysén del Gral. Ibañez del Campo',
    "code": "AY",
    "id": "CH-AY"
  },
  {
    "countryId": "152", //Chile
    "name": "Magallanes",
    topoName: 'Magallanes y Antártica Chilena',
    "code": "MG",
    "id": "CH-MG"
  },
  {
    "countryId": "156", //China
    "name": "Anhui Province",
    jhName: 'Anhui',
    "code": "AN",
    "id": "ZH-AN"
  },
  {
    "countryId": "156", //China
    "name": "Beijing Municipality",
    jhName: 'Beijing',
    "code": "BJ",
    "id": "ZH-BJ"
  },
  {
    "countryId": "156", //China
    "name": "Chongqing Municipality",
    jhName: 'Chongqing',
    "code": "CH",
    "id": "ZH-CH"
  },
  {
    "countryId": "156", //China
    "name": "Fujian Province",
    jhName: 'Fujian',
    "code": "FJ",
    "id": "ZH-FJ"
  },
  {
    "countryId": "156", //China
    "name": "Guangdong Province",
    jhName: 'Guangdong',
    "code": "GD",
    "id": "ZH-GD"
  },
  {
    "countryId": "156", //China
    "name": "Gansu Province",
    jhName: 'Gansu',
    "code": "GS",
    "id": "ZH-GS"
  },
  {
    "countryId": "156", //China
    "name": "Guangxi Autonomous Region",
    jhName: 'Guangxi',
    populationName: 'Guangxi Zhuang Autonomous Region',
    "code": "GX",
    "id": "ZH-GX"
  },
  {
    "countryId": "156", //China
    "name": "Guizhou Province",
    jhName: 'Guizhou',
    "code": "GZ",
    "id": "ZH-GZ"
  },
  {
    "countryId": "156", //China
    "name": "Henan Province",
    jhName: 'Henan',
    "code": "HE",
    "id": "ZH-HE"
  },
  {
    "countryId": "156", //China
    "name": "Hubei Province",
    jhName: 'Hubei',
    "code": "HU",
    "id": "ZH-HU"
  },
  {
    "countryId": "156", //China
    "name": "Hebei Province",
    jhName: 'Hebei',
    "code": "HB",
    "id": "ZH-HB"
  },
  {
    "countryId": "156", //China
    "name": "Hainan Province",
    jhName: 'Hainan',
    "code": "HA",
    "id": "ZH-HA"
  },
  {
    "countryId": "156", //China
    "name": "Hong Kong",
    populationName: 'Hong Kong Special Administrative Region',
    topoName: 'Hong Kong Administrative Region',
    "code": "HK",
    "id": "ZH-HK"
  },
  {
    "countryId": "156", //China
    "name": "Macau",
    populationName: 'Macau Special Administrative Region',
    topoName: 'Macau Administrative Region',
    "code": "MA",
    "id": "ZH-MA"
  },
  {
    "countryId": "156", //China
    "name": "Heilongjiang Province",
    jhName: 'Heilongjiang',
    "code": "HL",
    "id": "ZH-HL"
  },
  {
    "countryId": "156", //China
    "name": "Hunan Province",
    jhName: 'Hunan',
    "code": "HN",
    "id": "ZH-HN"
  },
  {
    "countryId": "156", //China
    "name": "Jilin Province",
    jhName: 'Jilin',
    "code": "JI",
    "id": "ZH-JI"
  },
  {
    "countryId": "156", //China
    "name": "Jiangsu Province",
    jhName: 'Jiangsu',
    "code": "JG",
    "id": "ZH-JG"
  },
  {
    "countryId": "156", //China
    "name": "Jiangxi Province",
    jhName: 'Jiangxi',
    "code": "JX",
    "id": "ZH-JX"
  },
  {
    "countryId": "156", //China
    "name": "Liaoning Province",
    jhName: 'Liaoning',
    "code": "LI",
    "id": "ZH-LI"
  },
  {
    "countryId": "156", //China
    "name": "Inner Mongolia",
    topoName: 'Nei Mongol Autonomous Region',
    jhName: 'Inner Mongolia',
    populationName: 'Inner Mongolia Autonomous Region',
    "code": "IM",
    "id": "ZH-IM"
  },
  {
    "countryId": "156", //China
    "name": "Ningxia Hui",
    topoName: 'Ningxia Hui Autonomous Region',
    jhName: 'Ningxia',
    "code": "NG",
    "id": "ZH-NG"
  },
  {
    "countryId": "156", //China
    "name": "Qinghai Province",
    jhName: 'Qinghai',
    "code": "QI",
    "id": "ZH-QI"
  },
  {
    "countryId": "156", //China
    "name": "Sichuan Province",
    jhName: 'Sichuan',
    "code": "SI",
    "id": "ZH-SI"
  },
  {
    "countryId": "156", //China
    "name": "Shandong Province",
    jhName: 'Shandong',
    "code": "SH",
    "id": "ZH-SH"
  },
  {
    "countryId": "156", //China
    "name": "Shanghai Municipality",
    jhName: 'Shanghai',
    "code": "SG",
    "id": "ZH-SG"
  },
  {
    "countryId": "156", //China
    "name": "Shaanxi Province",
    jhName: 'Shaanxi',
    "code": "SA",
    "id": "ZH-SA"
  },
  {
    "countryId": "156", //China
    "name": "Shanxi Province",
    jhName: 'Shanxi',
    "code": "SX",
    "id": "ZH-SX"
  },
  {
    "countryId": "156", //China
    "name": "Tianjin Municipality",
    jhName: 'Tianjin',
    "code": "TJ",
    "id": "ZH-TJ"
  },
  // {
  //   "countryId": "156", //China
  //   "name": "Taiwan Province",
  //   jhName: 'Taiwan',
  //   "code": "TA",
  //   "id": "ZH-TA"
  // },
  {
    "countryId": "156", //China
    "name": "Xinjiang Uyghur Autonomous Region",
    jhName: 'Xinjiang',
    topoName: 'Xinjiang Uygur Autonomous Region',
    "code": "XI",
    "id": "ZH-XI"
  },
  {
    "countryId": "156", //China
    "name": "Tibet",
    populationName: 'Tibet Autonomous Region',
    topoName: 'Xizang Autonomous Region',
    "code": "TI",
    "id": "ZH-TI"
  },
  {
    "countryId": "156", //China
    "name": "Yunnan Province",
    jhName: 'Yunnan',
    "code": "YN",
    "id": "ZH-YN"
  },
  {
    "countryId": "156", //China
    "name": "Zhejiang Province",
    jhName: 'Zhejiang',
    "code": "ZH",
    "id": "ZH-ZH"
  },




  //
];

export function getSubnationalUnitByName(_name, countryId) {
  const name = _name.toLowerCase()
  return subnationalUnits.find(c =>
    (
      c.name.toLowerCase() === name  ||
      (c.jhName && c.jhName.toLowerCase() === name) ||
      (c.topoName && c.topoName.toLowerCase() === name) ||
      (c.populationName && c.populationName.toLowerCase()) === name
    ) && c.countryId === countryId);
};

export function getSubnationalUnitByCode(code) {
  return subnationalUnits.find(c => c.code === code);
};

export function getSubnationalUnitById(id) {
  return subnationalUnits.find(n => n.id === id);
};
